import { styled } from '@mui/material/styles'
import { ToggleButtonGroupProps, ToggleButtonGroup } from '@mui/material'

export const CustomToggleButtonGroup = styled(
  ToggleButtonGroup
)<ToggleButtonGroupProps>(({ theme }) => ({
  '&.MuiToggleButtonGroup-root ': {
    gap: '24px',
    '& .MuiButtonBase-root': {},
    '.MuiToggleButtonGroup-grouped': {
      borderRadius: '12px',
      '&:not(:last-of-type)': {
        borderColor: 'none',
      },
      '&:not(:first-of-type)': {
        borderColor: 'none',
      },
      [theme.breakpoints.down(900)]: {
        borderRadius: '24px',
      },
    },
    [theme.breakpoints.down(900)]: {
      gap: '12px',
    },
    [theme.breakpoints.down('sm')]: {
      gap: '12px 8px',
    },
  },
}))
export default CustomToggleButtonGroup
